import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, NavItem, NavLink } from 'reactstrap';
import { companyTypes, resources, UserContext } from '../../constants';
import { logout } from '../helpers/HelperFunctions';
import Burger from '../pages/Burger';
import { Svg } from '../Svg';
import i18next from "../../i18n";
export function NavMenuItem(props) {
    const { title, name, url, classes, menuItems, src, target } = props;
    let items = [];
    if (menuItems) {
        for (let i = 0; i < menuItems.length; i++) {
            let item = menuItems[i];
            if (!item.hiddenForMenu)
                items.push(<NavMenuItem key={item.name ? item.name : i} isRoot={false} menuItems={item.menuItems} target={item.target} classes={item.class + " dropdown-item"} type={item.type} title={item.link.text} name={item.name} src={item.icone} count={item.count} url={item.link.url} />)
        }
    }
    if (items.length > 0)
        return (<div className="nav-link">
            <Svg src={src} className="nav-menu-icone" />
            <div className="dropdown">
                <div className="dropdown-btn" id={"nav-btn" + name} data-toggle="dropdown">
                    <span>{title}</span>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M11.293 15.7071L6.29297 10.7071L7.70718 9.29291L12.0001 13.5858L16.293 9.29291L17.7072 10.7071L12.7072 15.7071C12.3167 16.0976 11.6835 16.0976 11.293 15.7071Z" fill="black" />
                    </svg>
                </div>
                <div className="dropdown-menu" aria-labelledby={"nav-btn" + name}>
                    {items.map(item =>
                        item
                    )}
                </div>
            </div>
        </div>)
    else
        return (
            <NavLink tag={Link} className={classes ? classes : ""} to={url} target={target}>
                {src && <Svg src={src} className="nav-menu-icone" />}
                <span>{title}</span>
            </NavLink>
        );
}
export class NavMenu extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true,
            menuOpen: false,
            isOpenLeftMenu: false,
            menuItems: []
        };
        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.handleOpenLeftMenu = this.handleOpenLeftMenu.bind(this);
        this.hideOverMob = this.hideOverMob.bind(this);
        this.handleChangeCompany = this.handleChangeCompany.bind(this);
    }
    componentDidMount() {
        this.getMenu();
    }
    componentDidUpdate() {
        if (this.props.isOpenLeftMenu !== this.state.isOpenLeftMenu) {
            this.setState({
                isOpenLeftMenu: this.props.isOpenLeftMenu
            });
        }
    }
    toggleNavbar() {
        this.setState({ collapsed: !this.state.collapsed });
    }
    handleMenuClick() {
        this.setState({ menuOpen: !this.state.menuOpen });
    }
    handleLinkClick() {
        this.setState({ menuOpen: false });
    }
    handleOpenLeftMenu() {
        let isOpen = !this.state.isOpenLeftMenu;
        this.setState({
            isOpenLeftMenu: isOpen
        });
        if (this.props.handleOpenLeftMenu)
            this.props.handleOpenLeftMenu(isOpen);
    }
    hideOverMob() {
        this.setState({
            menuOpen: false
        });
    }
    render() {
        const { menuItems } = this.state;
        const menuItem = this.context.mainMenuItem;
        return menuItems.length > 0 ? <>
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white box-shadow" light>
                    <button type="button" className={"BtnMobileLeftBar" + (this.state.isOpenLeftMenu ? " active" : "")} onClick={this.handleOpenLeftMenu} >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 6L8 6L8 8L21 8L21 6ZM21 11L11 11L11 13L21 13L21 11ZM21 18L21 16L8 16L8 18L21 18ZM3 8.41L6.58 12L3 15.59L4.41 17L9.41 12L4.41 7L3 8.41Z" fill="black" />
                        </svg>
                    </button>
                    <div className="main-logo">
                        <NavLink tag={Link} to="/">
                            <img src="/img/logo_v2.svg" width="188" height="50" alt="Logo" />
                        </NavLink>
                    </div>
                    <div className={this.state.menuOpen ? "menuMobile open" : "menuMobile"} open={this.state.menuOpen}>
                        <ul className="navbar-nav flex-grow">
                            {menuItems && menuItems.length > 0 &&
                                menuItems.map((item, index) =>
                                    <NavItem key={index++}>
                                        <NavMenuItem title={item.link.text} name={item.name} target={item.target} menuItems={item.menuItems} classes={item.classes} src={item.image.path} url={item.link.url} isRoot={true} />
                                    </NavItem>
                                )
                            }
                        </ul>
                        <div className="account-info-block">
                            <div className="dropdown">
                                <div className="dropdown-btn" id="account-info-nav-btn" data-toggle="dropdown">
                                    <div className="account-info">
                                        <div>
                                            <div className="account-info-name">{this.context.userName}</div>
                                            <div className="account-info-key">{this.context.companies[0].companyShortName}</div>
                                        </div>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M11.293 15.7071L6.29297 10.7071L7.70718 9.29291L12.0001 13.5858L16.293 9.29291L17.7072 10.7071L12.7072 15.7071C12.3167 16.0976 11.6835 16.0976 11.293 15.7071Z" fill="black" fillOpacity="0.6" />
                                        </svg>
                                    </div>
                                </div>
                                <div className="dropdown-menu" aria-labelledby="account-info-nav-btn">
                                    {this.context.companies.map((item, index) =>
                                        <div key={index} id={item.registerCode} className="dropdown-menu-item" onClick={() => this.handleChangeCompany(item.id)}>
                                            <div className="dropdown-menu-item-content">
                                                {index === 0 && <p className="mob-h"><b>{this.context.userName}</b><br /></p>}
                                                {
                                                    companyTypes.Entity === item.companyTypeValue || companyTypes.Individual === item.companyTypeValue
                                                        ?
                                                        <p>
                                                            {item.companyShortName && <span className="mob-h">{item.companyShortName}<br /></span>}
                                                            {item.companyTypeValue === companyTypes.Entity ? `${i18next.t("EDRPOUCodeShort")} ` : ""}
                                                            {item.companyTypeValue === companyTypes.Individual ? `${i18next.t("TINCodeShort")} ` : ""}
                                                            {item.registerCode}<br />
                                                        </p> :
                                                        ""}
                                                <p>{this.context.email}</p>
                                            </div>
                                        </div>)}
                                    <ul className="action-list">
                                        {menuItem ?
                                            <li><NavLink tag={Link} to={menuItem.url}>{menuItem.text}</NavLink></li>
                                            : ""}
                                        <li className="last"><a onClick={logout}>{i18next.t("logout")}</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="logout-btn" onClick={logout}>
                                <a>
                                    <span>{i18next.t("logout")}</span>
                                    <Svg src={resources.logoutIcone} />
                                </a>
                            </div>
                        </div>
                    </div>
                    <Burger open={this.state.menuOpen} onClick={() => this.handleMenuClick()} color='black' />
                </Navbar>
            </header>
            <div className={this.state.menuOpen ? "overMob open" : "overMob"} onClick={this.hideOverMob}></div>
        </> : "";
    }
    async getMenu() {
        const response = await fetch(`menu/GetNavMenu?companyKind=${this.context.companies[0].companyKindValue}`);
        if (!response.ok) return require('../ModalDialogsTemplates').unknownErrorMessageDialog();
        const data = await response.json();
        this.setState({ menuItems: data.menuItems });
    }
    handleChangeCompany(companyId) {
        const context = this.context;
        const selectedCompanyIndex = context.companies.findIndex((item) => item.id === companyId);
        const selectedCompany = context.companies[selectedCompanyIndex];
        context.companies.splice(selectedCompanyIndex, 1);
        context.companies.unshift(selectedCompany);
        localStorage.setItem("user", JSON.stringify(context));
        window.onbeforeunload = null;
        window.location.replace("/");
    }
}
